function getType(context) {
  return context.$route.path.includes('routecontrols') ? 'tc' : 'site';
}

const privs = {
  site: 'pr_site',
  tc: 'pr_tc'
};

const urls = {
  site: '/sites/reporttypes',
  tc: '/routecontrols/reporttypes'
};

const filterNames = {
  site: 'sitereporttypes',
  tc: 'tcreporttypes'
};

const deviceGroupIds = {
  site: 3,
  tc: 6
};

export default {
  priv(context) {
    return privs[getType(context)];
  },
  overviewTitle: 'Rapport Types',
  detailTitle: 'Rapport Type',
  deleteTitle: 'dit rapport type',
  url(context) {
    return urls[getType(context)];
  },
  apiUrl: '/siteinfos/',
  sortBy: ['desc'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName(context) {
    return filterNames[getType(context)];
  },
  quickFilter: {
    text: 'Zoek op naam',
    value: 'desc',
    type: 'text'
  },
  tableFields(context) {
    return [
      {
        text: 'Naam',
        value: 'desc',
        link: urls[getType(context)] + '/{id}',
        width: '90%'
      }
    ];
  },
  newRecord(context) {
    return {
      devicegroup_id: deviceGroupIds[getType(context)]
    };
  }
};
